(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landie-cart-drawer"]) return;
  try {
    
  (function () {
    const DIALOG_ID = 'LandieCartDrawer';
    const SECTION_ID = 'landie-cart-drawer';
    const STORAGE_KEY = 'landie-dismissed-upsells';
    const TRIGGER_SELECTOR = '[data-landie-cart-open]';
    const CLOSE_SELECTOR = '[data-landie-cart-close]';
    const FORM_SELECTOR = '.landie-pdp-form';
    const COUNT_SELECTOR = '[data-landie-cart-count]';

    function getDismissed() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      } catch (_) { return []; }
    }

    function addDismissed(handle) {
      const list = getDismissed();
      if (!list.includes(handle)) list.push(handle);
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (_) {}
    }

    class LandieCart {
      constructor() {
        this.dialog = document.getElementById(DIALOG_ID);
        if (!this.dialog) return;
        this.bind();
        this.bindCrossTabSync();
        this.applyDismissedUpsells();
        this.checkPendingCheckout();
      }

      bindCrossTabSync() {
        // Sync between tabs in the same browser via BroadcastChannel.
        try {
          this.channel = new BroadcastChannel('landie-cart');
          this.channel.addEventListener('message', (event) => {
            if (event && event.data && event.data.type === 'cart-updated') {
              this.refreshSection().catch(() => {});
            }
          });
        } catch (_) {
          this.channel = null;
        }

        // Catch tabs that were backgrounded: refresh when they come back.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            this.refreshSection().catch(() => {});
          }
        });
      }

      broadcast() {
        if (this.channel) {
          try { this.channel.postMessage({ type: 'cart-updated' }); } catch (_) {}
        }
      }

      bind() {
        document.addEventListener('click', (event) => {
          if (event.target.closest(TRIGGER_SELECTOR)) {
            event.preventDefault();
            this.open();
            return;
          }
          if (this.dialog.contains(event.target)) {
            if (event.target.closest(CLOSE_SELECTOR)) {
              event.preventDefault();
              this.close();
              return;
            }
            const qtyBtn = event.target.closest('[data-landie-cart-qty]');
            if (qtyBtn) {
              event.preventDefault();
              const next = parseInt(qtyBtn.dataset.qty, 10);
              if (!Number.isNaN(next) && next >= 0) {
                this.changeQuantity(qtyBtn.dataset.key, next);
              }
              return;
            }
            const bannerCloseBtn = event.target.closest('[data-landie-cart-banner-close]');
            if (bannerCloseBtn) {
              event.preventDefault();
              const banner = bannerCloseBtn.closest('[data-landie-cart-banner]');
              if (banner) banner.remove();
              return;
            }
            const clearBtn = event.target.closest('[data-landie-cart-clear]');
            if (clearBtn) {
              event.preventDefault();
              this.clearCart(clearBtn);
              return;
            }
            const yesBtn = event.target.closest('[data-landie-cart-upsell-yes]');
            if (yesBtn) {
              event.preventDefault();
              const card = yesBtn.closest('[data-landie-cart-upsell]');
              if (card) this.addVariant(card.dataset.upsellVariantId, yesBtn);
              return;
            }
            const noBtn = event.target.closest('[data-landie-cart-upsell-no]');
            if (noBtn) {
              event.preventDefault();
              const card = noBtn.closest('[data-landie-cart-upsell]');
              if (card) {
                addDismissed(card.dataset.upsellHandle);
                card.remove();
              }
              return;
            }
          }
        });

        document.addEventListener('submit', (event) => {
          const form = event.target.closest(FORM_SELECTOR);
          if (!form) return;
          event.preventDefault();
          this.addFromForm(form);
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      async refreshSection() {
        const res = await fetch('/?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Section refresh failed: ' + res.status);
        const json = await res.json();
        const html = json[SECTION_ID];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const incoming = doc.querySelector('#' + DIALOG_ID);
        if (!incoming) return;

        // Preserve the dialog element itself (so [open] state stays); swap inner HTML.
        this.dialog.innerHTML = incoming.innerHTML;

        // Update header bubble count from the freshly rendered title count.
        const titleCount = this.dialog.querySelector('[data-landie-cart-count-display]');
        if (titleCount) {
          const n = titleCount.textContent;
          document.querySelectorAll(COUNT_SELECTOR).forEach((el) => { el.textContent = n; });
        }

        this.applyDismissedUpsells();
      }

      applyDismissedUpsells() {
        const dismissed = getDismissed();
        if (!dismissed.length) return;
        const upsell = this.dialog.querySelector('[data-landie-cart-upsell]');
        if (upsell && dismissed.includes(upsell.dataset.upsellHandle)) {
          upsell.remove();
        }
      }

      async addFromForm(form) {
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.innerHTML : null;
        if (btn) { btn.disabled = true; btn.innerHTML = 'Adding...'; }
        try {
          window.landieBreadcrumb('cart: add to cart');
          const fd = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) {
            const msg = await this.extractError(res);
            window.landieCapture(new Error('add to cart failed: HTTP ' + res.status), { tags: { flow: 'cart', step: 'add_to_cart' } });
            this.showBanner(msg);
            this.open();
            return;
          }
          await this.refreshSection();
          this.broadcast();
          this.open();
        } catch (err) {
          console.error('[landie-cart] add failed:', err);
          window.landieCapture(err, { tags: { flow: 'cart', step: 'add_to_cart' } });
          this.showBanner('Sorry — something went wrong. Please try again.');
          this.open();
        } finally {
          if (btn) { btn.disabled = false; if (original !== null) btn.innerHTML = original; }
        }
      }

      async addVariant(variantId, btn) {
        if (!variantId) return;
        const original = btn ? btn.innerHTML : null;
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = '<span class="landie-cart-drawer__spinner" aria-hidden="true"></span>Adding…';
        }
        try {
          window.landieBreadcrumb('cart: upsell add', { variantId: variantId });
          const fd = new FormData();
          fd.append('id', String(variantId));
          fd.append('quantity', '1');
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!res.ok) {
            const msg = await this.extractError(res);
            window.landieCapture(new Error('upsell add failed: HTTP ' + res.status), { tags: { flow: 'cart', step: 'upsell_add' } });
            this.showBanner(msg);
            return;
          }
          await this.refreshSection();
          this.broadcast();
        } catch (err) {
          console.error('[landie-cart] upsell add failed:', err);
          window.landieCapture(err, { tags: { flow: 'cart', step: 'upsell_add' } });
          this.showBanner('Sorry — something went wrong. Please try again.');
        } finally {
          // On success refreshSection() replaces the card, so this only restores
          // the button on the error paths where it's still in the DOM.
          if (btn && btn.isConnected) { btn.disabled = false; if (original !== null) btn.innerHTML = original; }
        }
      }

      async changeQuantity(key, quantity) {
        if (!key) return;
        try {
          window.landieBreadcrumb('cart: quantity change', { quantity: quantity });
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
          if (!res.ok) {
            const msg = await this.extractError(res);
            window.landieCapture(new Error('quantity change failed: HTTP ' + res.status), { tags: { flow: 'cart', step: 'qty_change' } });
            this.showBanner(msg);
            return;
          }
          await this.refreshSection();
          this.broadcast();
        } catch (err) {
          console.error('[landie-cart] quantity change failed:', err);
          window.landieCapture(err, { tags: { flow: 'cart', step: 'qty_change' } });
          this.showBanner('Sorry — something went wrong. Please try again.');
        }
      }

      async extractError(res) {
        try {
          const data = await res.json();
          return data.description || data.message || 'Could not update cart.';
        } catch (_) {
          return 'Could not update cart.';
        }
      }

      showBanner(message) {
        const contents = this.dialog.querySelector('.landie-cart-drawer__contents');
        if (!contents) return;
        const existing = contents.querySelector('[data-landie-cart-banner]');
        if (existing) existing.remove();
        const banner = document.createElement('div');
        banner.className = 'landie-cart-drawer__banner';
        banner.setAttribute('data-landie-cart-banner', '');
        const text = document.createElement('p');
        text.className = 'landie-cart-drawer__banner-text';
        text.textContent = message;
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'landie-cart-drawer__banner-clear';
        clear.setAttribute('data-landie-cart-clear', '');
        clear.textContent = 'Clear cart';
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'landie-cart-drawer__banner-close';
        close.setAttribute('data-landie-cart-banner-close', '');
        close.setAttribute('aria-label', 'Dismiss');
        close.textContent = '×';
        banner.appendChild(text);
        banner.appendChild(clear);
        banner.appendChild(close);
        contents.prepend(banner);
      }

      async clearCart(btn) {
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = '<span class="landie-cart-drawer__spinner" aria-hidden="true"></span>Clearing…';
        }
        try {
          const res = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) {
            const msg = await this.extractError(res);
            window.landieCapture(new Error('cart clear failed: HTTP ' + res.status), { tags: { flow: 'cart', step: 'clear_cart' } });
            this.showBanner(msg);
            return;
          }
          await this.refreshSection();
          this.broadcast();
        } catch (err) {
          console.error('[landie-cart] clear failed:', err);
          window.landieCapture(err, { tags: { flow: 'cart', step: 'clear_cart' } });
          this.showBanner('Sorry — something went wrong. Please try again.');
        }
      }

      // After /cart checkout, we stash the Storefront cart id in localStorage.
      // On the customer's next visit, if that cart has converted (order placed)
      // or vanished, empty the Ajax cart so the drawer doesn't show stale items.
      // A still-open cart is left alone so abandoned-checkout recovery works.
      dropPending() {
        try { localStorage.removeItem('landie_pending_cart'); } catch (_) {}
      }

      async clearLocalCart() {
        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          await this.refreshSection();
          this.broadcast();
        } catch (_) {}
      }

      async checkPendingCheckout() {
        let raw;
        try { raw = localStorage.getItem('landie_pending_cart'); } catch (_) { return; }
        if (!raw) return;

        let marker;
        try { marker = JSON.parse(raw); } catch (_) { marker = null; }
        if (!marker || !marker.id) { this.dropPending(); return; }

        // Stale-marker guard: never act on a marker older than 24h, so an old
        // abandoned cart that later expires can't wipe a freshly built one.
        if (Date.now() - (marker.ts || 0) > 24 * 60 * 60 * 1000) { this.dropPending(); return; }

        const token = (this.dialog.dataset.storefrontToken || '').trim();
        const domain = this.dialog.dataset.shopDomain;
        const version = this.dialog.dataset.apiVersion || '2025-01';
        if (!token || !domain) return;

        try {
          const res = await fetch('https://' + domain + '/api/' + version + '/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Shopify-Storefront-Access-Token': token,
            },
            body: JSON.stringify({ query: 'query($id:ID!){cart(id:$id){id totalQuantity}}', variables: { id: marker.id } }),
          });
          const json = await res.json();
          if (json.errors) return; // couldn't determine status; retry next visit
          const cart = json.data ? json.data.cart : null;
          if (cart && cart.totalQuantity > 0) return; // checkout still open — leave cart + marker
          // null/empty => order placed (or cart gone) => clear the local cart
          this.dropPending();
          await this.clearLocalCart();
        } catch (_) { /* keep marker; retry next visit */ }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => { window.landieCart = new LandieCart(); });
    } else {
      window.landieCart = new LandieCart();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landie-cart-page"]) return;
  try {
    
  (function () {
    const ROOT_ID = 'LandieCartPage';

    // Maps the AU state codes used by the form to the full province name, so
    // residence attributes mirror Shopify's shipping_address (province + code).
    const PROVINCE_NAMES = {
      NSW: 'New South Wales',
      VIC: 'Victoria',
      QLD: 'Queensland',
      WA: 'Western Australia',
      SA: 'South Australia',
      TAS: 'Tasmania',
      ACT: 'Australian Capital Territory',
      NT: 'Northern Territory',
    };

    // One reusable cart drives both live discount pricing and the final
    // checkout, so we never spawn a cart per Apply click.
    const CART_FIELDS = `
      id
      checkoutUrl
      cost { totalAmount { amount currencyCode } }
      discountCodes { code applicable }
      discountAllocations { discountedAmount { amount currencyCode } }
      lines(first: 50) {
        edges { node { discountAllocations { discountedAmount { amount currencyCode } } } }
      }`;

    const CART_CREATE = `
      mutation cartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart { ${CART_FIELDS} }
          userErrors { field message }
        }
      }`;

    const CART_DISCOUNT_UPDATE = `
      mutation cartDiscountCodesUpdate($cartId: ID!, $codes: [String!]!) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {
          cart { ${CART_FIELDS} }
          userErrors { field message }
        }
      }`;

    const CART_ATTRS_UPDATE = `
      mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
        cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
          cart { id }
          userErrors { field message }
        }
      }`;

    const CART_BUYER_UPDATE = `
      mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart { checkoutUrl }
          userErrors { field message }
        }
      }`;

    const CART_GET = `
      query cartGet($id: ID!) {
        cart(id: $id) {
          id
          totalQuantity
          cost { totalAmount { amount currencyCode } }
          discountCodes { code applicable }
          discountAllocations { discountedAmount { amount currencyCode } }
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                merchandise { ... on ProductVariant { id } }
                discountAllocations { discountedAmount { amount currencyCode } }
              }
            }
          }
        }
      }`;

    const CART_LINES_UPDATE = `
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart { id }
          userErrors { field message }
        }
      }`;

    class LandieCheckout {
      constructor() {
        this.root = document.getElementById(ROOT_ID);
        if (!this.root) return;
        this.form = this.root.querySelector('[data-landie-co-form]');
        if (!this.form) return;

        this.domain = this.root.dataset.shopDomain;
        this.version = this.root.dataset.apiVersion || '2025-01';
        this.token = (this.root.dataset.storefrontToken || '').trim();
        this.mapsKey = (this.root.dataset.googleMapsKey || '').trim();
        this.cardProp = this.root.dataset.cardProperty || 'Name';
        this.discountCode = '';
        this.cartId = null;
        this.checkoutUrl = null;

        const totalEl = this.root.querySelector('[data-landie-co-total]');
        this.originalTotal = totalEl ? totalEl.textContent : '';

        this.bind();
        this.hydrate();
      }

      bind() {
        const same = this.form.querySelector('[data-landie-co-residence-same]');
        const fields = this.form.querySelector('[data-landie-co-residence-fields]');
        if (same && fields) {
          const sync = () => { fields.hidden = same.checked; };
          same.addEventListener('change', sync);
          sync();
        }

        const applyBtn = this.root.querySelector('[data-landie-co-discount-apply]');
        const discountInput = this.root.querySelector('[data-landie-co-discount-input]');
        const removeBtn = this.root.querySelector('[data-landie-co-discount-remove]');
        if (applyBtn) applyBtn.addEventListener('click', () => this.applyDiscount());
        if (discountInput) {
          discountInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); this.applyDiscount(); }
          });
        }
        if (removeBtn) removeBtn.addEventListener('click', () => this.removeDiscount());

        this.form.querySelectorAll('[data-landie-co-card-input]').forEach((input) => {
          input.addEventListener('blur', () => this.saveCardLine(input.dataset.line));
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
          });
          input.addEventListener('input', () => {
            input.classList.remove('landie-co__card-input--saved');
            // Clear the required-field error once the shopper starts typing a name.
            if (input.value.trim()) {
              input.classList.remove('landie-co__input--invalid');
              const card = input.closest('[data-landie-co-card]');
              const err = card && card.querySelector('[data-landie-co-card-error]');
              if (err && !card.querySelector('[data-landie-co-card-input].landie-co__input--invalid')) err.hidden = true;
            }
          });
        });

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submit();
        });

        // Google Places autocomplete — additive, no-ops without a key/library.
        this.initAddressAutocomplete('', '[data-landie-co-address-search]');
        this.initAddressAutocomplete('residence_', '[data-landie-co-residence-search]');
      }

      val(name) {
        const el = this.form.elements[name];
        return el ? String(el.value || '').trim() : '';
      }

      // Mount a Google PlaceAutocompleteElement into `mountSelector`; on selection
      // it fills the prefixed address fields (e.g. '' for shipping, 'residence_').
      // Fails closed: any missing key/library/element leaves the manual inputs alone.
      async initAddressAutocomplete(prefix, mountSelector) {
        if (!this.mapsKey) return;
        if (!window.google || !window.google.maps || !window.google.maps.importLibrary) return;
        const mount = this.root.querySelector(mountSelector);
        if (!mount || mount.dataset.landieAcReady) return;

        let PlaceAutocompleteElement;
        try {
          ({ PlaceAutocompleteElement } = await window.google.maps.importLibrary('places'));
        } catch (err) {
          console.warn('[landie-co] Places library failed to load:', err);
          return;
        }
        if (!PlaceAutocompleteElement) return;

        // Restrict to AU + street-level results only (excludes businesses/POIs).
        // includedPrimaryTypes takes specific place types — NOT the legacy 'address'
        // collection (rejected) — so we use the two fundamental address types:
        // 'street_address' (full addresses) + 'route' (street names, so predictions
        // still appear before a house number is typed).
        let el;
        try {
          el = new PlaceAutocompleteElement({
            includedRegionCodes: ['au'],
            includedPrimaryTypes: ['street_address', 'route'],
          });
        } catch (err) {
          // Older signature / option rejection — fall back to a bare element.
          try {
            el = new PlaceAutocompleteElement();
          } catch (err2) {
            console.warn('[landie-co] PlaceAutocompleteElement unavailable:', err2);
            return;
          }
        }

        mount.appendChild(el);
        mount.dataset.landieAcReady = '1';

        el.addEventListener('gmp-select', async (event) => {
          const place = event.placePrediction ? event.placePrediction.toPlace() : event.place;
          if (!place) return;
          try {
            await place.fetchFields({ fields: ['addressComponents'] });
          } catch (err) {
            console.warn('[landie-co] fetchFields failed:', err);
            return;
          }
          this.fillAddressFromPlace(prefix, place);
        });
      }

      // Map AU address components onto the structured fields and clear stale errors.
      fillAddressFromPlace(prefix, place) {
        const components = place.addressComponents || [];
        const get = (type) => {
          const c = components.find((comp) => (comp.types || []).indexOf(type) !== -1);
          return c ? { long: c.longText || '', short: c.shortText || '' } : null;
        };
        const longOf = (type) => {
          const c = get(type);
          return c ? c.long : '';
        };

        const streetNumber = longOf('street_number');
        const route = longOf('route');
        const address1 = [streetNumber, route].filter(Boolean).join(' ').trim();

        const city =
          longOf('locality') ||
          longOf('sublocality') ||
          longOf('sublocality_level_1') ||
          longOf('postal_town') ||
          longOf('administrative_area_level_2');

        const stateComp = get('administrative_area_level_1');
        const province = stateComp ? stateComp.short : '';
        const zip = longOf('postal_code');

        const set = (name, value) => {
          if (!value) return;
          const el = this.form.elements[prefix + name];
          if (!el) return;
          // Only assign a <select> value that actually exists as an option.
          if (el.tagName === 'SELECT') {
            const ok = Array.prototype.some.call(el.options, (o) => o.value === value);
            if (!ok) return;
          }
          el.value = value;
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
          el.classList.remove('landie-co__input--invalid');
        };

        set('address1', address1);
        set('city', city);
        set('province', province);
        set('zip', zip);
      }

      markInvalid(name, message) {
        const el = this.form.elements[name];
        if (el) el.classList.add('landie-co__input--invalid');
        const err = this.form.querySelector('[data-error-for="' + name + '"]');
        if (err && message) { err.textContent = message; err.hidden = false; }
      }

      clearErrors() {
        this.form.querySelectorAll('.landie-co__input--invalid').forEach((el) => el.classList.remove('landie-co__input--invalid'));
        this.form.querySelectorAll('.landie-co__error').forEach((el) => { el.hidden = true; });
        this.clearBanner();
      }

      validate() {
        let firstInvalid = null;
        const fail = (name, msg) => {
          this.markInvalid(name, msg);
          if (!firstInvalid) firstInvalid = this.form.elements[name];
        };

        // Every printed calling card needs a name — block checkout if any are blank.
        this.form.querySelectorAll('[data-landie-co-card]').forEach((card) => {
          const inputs = Array.prototype.slice.call(card.querySelectorAll('[data-landie-co-card-input]'));
          const err = card.querySelector('[data-landie-co-card-error]');
          let cardInvalid = false;
          inputs.forEach((input) => {
            if (!input.value.trim()) {
              input.classList.add('landie-co__input--invalid');
              cardInvalid = true;
              if (!firstInvalid) firstInvalid = input;
            }
          });
          if (err && cardInvalid) { err.textContent = 'Enter a valid name'; err.hidden = false; }
        });

        const email = this.val('email');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) fail('email', 'Enter a valid email address.');

        const phoneDigits = this.val('phone').replace(/[^\d+]/g, '');
        // Australian mobile: 04xxxxxxxx (10 digits) or +614xxxxxxxx.
        if (!/^(?:\+?61|0)4\d{8}$/.test(phoneDigits)) fail('phone', 'Enter a valid Australian mobile (04xx xxx xxx).');

        ['first_name', 'last_name', 'address1', 'city', 'zip'].forEach((n) => {
          if (!this.val(n)) fail(n, 'Required.');
        });

        const same = this.form.elements['residence_same'];
        if (same && !same.checked) {
          ['residence_address1', 'residence_city', 'residence_zip'].forEach((n) => {
            if (!this.val(n)) fail(n, 'Required.');
          });
        }

        if (firstInvalid) {
          firstInvalid.focus();
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
        return true;
      }

      normalizePhone(raw) {
        const digits = raw.replace(/[^\d+]/g, '');
        if (digits.startsWith('+')) return digits;
        if (digits.startsWith('0')) return '+61' + digits.slice(1);
        if (digits.startsWith('61')) return '+' + digits;
        return digits;
      }

      async submit() {
        this.clearErrors();
        if (!this.validate()) return;

        if (!this.token) {
          this.showBanner('Checkout is not configured yet. Please add a Storefront API token in theme settings.');
          return;
        }

        const btn = this.form.querySelector('[data-landie-co-submit]');
        const original = btn ? btn.innerHTML : null;
        if (btn) { btn.disabled = true; btn.textContent = 'Setting up payment…'; }

        try {
          window.landieBreadcrumb('checkout: submit started');
          await this.flushCardNames();
          await this.ensureCart();

          // Carry across a code typed into the discount box but not yet Applied.
          const discInput = this.root.querySelector('[data-landie-co-discount-input]');
          const typed = discInput ? discInput.value.trim() : '';
          if (typed && typed !== this.discountCode) this.discountCode = typed;
          if (this.discountCode) {
            const dData = await this.gql(CART_DISCOUNT_UPDATE, { cartId: this.cartId, codes: [this.discountCode] });
            this.assertNoErrors(dData && dData.cartDiscountCodesUpdate, 'discount');
          }

          const same = this.form.elements['residence_same'];
          const sameChecked = same ? same.checked : true;
          const interested = this.form.elements['interested_more'];

          const attributes = [
            { key: 'landie.residence_same_as_shipping', value: sameChecked ? 'true' : 'false' },
            { key: 'landie.interested_in_more_landies', value: interested && interested.checked ? 'true' : 'false' },
          ];
          if (!sameChecked) {
            const resState = this.val('residence_province');
            attributes.push({ key: 'landie.residence.address1', value: this.val('residence_address1') });
            const resApt = this.val('residence_address2');
            if (resApt) attributes.push({ key: 'landie.residence.address2', value: resApt });
            attributes.push({ key: 'landie.residence.city', value: this.val('residence_city') });
            attributes.push({ key: 'landie.residence.province', value: PROVINCE_NAMES[resState] || resState });
            attributes.push({ key: 'landie.residence.province_code', value: resState });
            attributes.push({ key: 'landie.residence.zip', value: this.val('residence_zip') });
            attributes.push({ key: 'landie.residence.country', value: 'Australia' });
            attributes.push({ key: 'landie.residence.country_code', value: 'AU' });
          }
          const attrData = await this.gql(CART_ATTRS_UPDATE, { cartId: this.cartId, attributes: attributes });
          this.assertNoErrors(attrData && attrData.cartAttributesUpdate, 'attributes');

          const phone = this.normalizePhone(this.val('phone'));
          const deliveryAddress = {
            firstName: this.val('first_name'),
            lastName: this.val('last_name'),
            address1: this.val('address1'),
            city: this.val('city'),
            province: this.val('province'),
            zip: this.val('zip'),
            country: 'Australia',
            phone: phone,
          };
          const addr2 = this.val('address2');
          if (addr2) deliveryAddress.address2 = addr2;

          const biData = await this.gql(CART_BUYER_UPDATE, {
            cartId: this.cartId,
            buyerIdentity: {
              email: this.val('email'),
              phone: phone,
              countryCode: 'AU',
              deliveryAddressPreferences: [{ deliveryAddress: deliveryAddress }],
            },
          });
          const biPayload = biData && biData.cartBuyerIdentityUpdate;
          this.assertNoErrors(biPayload, 'buyer');

          const url = (biPayload.cart && biPayload.cart.checkoutUrl) || this.checkoutUrl;
          if (!url) throw new Error('No checkout URL');
          window.landieBreadcrumb('checkout: redirecting to hosted checkout');
          // Mark this checkout as pending so the drawer can empty the Ajax cart
          // on return *after* the order is placed (see landie-cart-drawer.liquid).
          try {
            localStorage.setItem('landie_pending_cart', JSON.stringify({ id: this.cartId, ts: Date.now() }));
          } catch (_) {}
          window.location.href = url;
          return; // keep button disabled during navigation
        } catch (err) {
          console.error('[landie-checkout] submit failed:', err);
          window.landieCapture(err, { tags: { flow: 'checkout', step: 'submit' }, extra: { cartId: this.cartId || null } });
          this.showBanner(
            err && err.userFacing
              ? err.message
              : 'Sorry — something went wrong setting up your checkout. Please try again.'
          );
        } finally {
          if (btn && document.body.contains(btn) && original !== null) {
            btn.disabled = false;
            btn.innerHTML = original;
          }
        }
      }

      money(value) {
        return '$' + (Math.round(value * 100) / 100).toFixed(2);
      }

      totalDiscount(cart) {
        let sum = 0;
        const add = (allocs) => {
          (allocs || []).forEach((a) => {
            sum += parseFloat((a.discountedAmount && a.discountedAmount.amount) || '0');
          });
        };
        add(cart.discountAllocations);
        if (cart.lines && cart.lines.edges) {
          cart.lines.edges.forEach((e) => { if (e && e.node) add(e.node.discountAllocations); });
        }
        return sum;
      }

      async applyDiscount() {
        const input = this.root.querySelector('[data-landie-co-discount-input]');
        const note = this.root.querySelector('[data-landie-co-discount-note]');
        const btn = this.root.querySelector('[data-landie-co-discount-apply]');
        const code = input ? input.value.trim() : '';
        const setNote = (msg) => { if (note) { note.textContent = msg || ''; note.hidden = !msg; } };

        if (!this.token) { setNote('Discounts are unavailable right now.'); return; }

        const original = btn ? btn.textContent : null;
        if (btn) { btn.disabled = true; btn.textContent = 'Checking…'; }
        try {
          await this.ensureCart();
          const data = await this.gql(CART_DISCOUNT_UPDATE, { cartId: this.cartId, codes: code ? [code] : [] });
          const payload = data && data.cartDiscountCodesUpdate;
          this.assertNoErrors(payload, 'discount');
          const cart = payload.cart;

          if (!code) { this.discountCode = ''; this.persistCart(); this.resetTotals(); setNote(''); return; }

          const applied = cart.discountCodes && cart.discountCodes.find((d) => d.applicable);
          if (!applied) {
            this.discountCode = '';
            this.persistCart();
            this.resetTotals();
            setNote('“' + code + '” isn’t a valid discount code.');
            return;
          }
          this.discountCode = applied.code;
          this.persistCart();
          this.applyTotals(cart.cost, this.totalDiscount(cart), applied.code);
          setNote('');
        } catch (err) {
          console.error('[landie-checkout] discount apply failed:', err);
          window.landieCapture(err, { tags: { flow: 'checkout', step: 'discount' }, extra: { cartId: this.cartId || null } });
          setNote('Could not check that code. Please try again.');
        } finally {
          if (btn && original !== null) { btn.disabled = false; btn.textContent = original; }
        }
      }

      async removeDiscount() {
        const input = this.root.querySelector('[data-landie-co-discount-input]');
        if (input) input.value = '';
        await this.applyDiscount();
      }

      applyTotals(cost, discountAmount, code) {
        const row = this.root.querySelector('[data-landie-co-discount-row]');
        const codeEl = this.root.querySelector('[data-landie-co-discount-code]');
        const amt = this.root.querySelector('[data-landie-co-discount-amount]');
        if (row && codeEl && amt && discountAmount > 0) {
          codeEl.textContent = code;
          amt.textContent = '−' + this.money(discountAmount);
          row.hidden = false;
          this.toggleDiscountInput(false);
        }
        const totalEl = this.root.querySelector('[data-landie-co-total]');
        if (totalEl && cost && cost.totalAmount) {
          const cur = this.root.dataset.currency || '';
          totalEl.textContent = (cur ? cur + ' ' : '') + this.money(parseFloat(cost.totalAmount.amount));
        }
      }

      resetTotals() {
        const row = this.root.querySelector('[data-landie-co-discount-row]');
        if (row) row.hidden = true;
        this.toggleDiscountInput(true);
        const totalEl = this.root.querySelector('[data-landie-co-total]');
        if (totalEl && this.originalTotal) totalEl.textContent = this.originalTotal;
      }

      toggleDiscountInput(show) {
        const group = this.root.querySelector('[data-landie-co-discount]');
        if (group) group.hidden = !show;
      }

      async saveCardLine(line) {
        const lineIndex = parseInt(line, 10);
        if (Number.isNaN(lineIndex)) return;
        const inputs = Array.prototype.slice.call(
          this.form.querySelectorAll('[data-landie-co-card-input][data-line="' + lineIndex + '"]')
        );
        if (!inputs.length) return;
        if (!inputs.some((inp) => inp.value.trim() !== (inp.dataset.saved || ''))) return; // nothing changed

        try {
          const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          const item = cart.items[lineIndex - 1];
          if (!item) return;

          // Preserve non-name properties; rebuild the per-unit name keys from the inputs.
          const props = {};
          const existing = item.properties || {};
          Object.keys(existing).forEach((k) => {
            if (k === this.cardProp || k.indexOf(this.cardProp + ' ') === 0) return;
            props[k] = existing[k];
          });
          inputs.forEach((inp) => {
            const v = inp.value.trim();
            if (v) props[inp.dataset.propKey] = v;
          });

          const change = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: item.quantity, properties: props }),
          });
          if (!change.ok) throw new Error('change.js ' + change.status);
          await this.syncCartLine(lineIndex, props);

          inputs.forEach((inp) => {
            inp.dataset.saved = inp.value.trim();
            if (inp.value.trim()) inp.classList.add('landie-co__card-input--saved');
          });
        } catch (err) {
          console.error('[landie-checkout] save card name failed:', err);
          window.landieCapture(err, { tags: { flow: 'checkout', step: 'card_name_save' } });
        }
      }

      // Keep the (already created) Storefront cart's line attributes in step with
      // the Ajax cart line, so the name reaches the order even if the cart was
      // built earlier (e.g. when a discount was applied first).
      async syncCartLine(lineIndex, props) {
        if (!this.cartId) return;
        const data = await this.gql(CART_GET, { id: this.cartId });
        const cart = data && data.cart;
        if (!cart || !cart.lines) return;
        const edge = cart.lines.edges[lineIndex - 1];
        if (!edge || !edge.node) return;
        const attributes = Object.keys(props)
          .filter((k) => k.charAt(0) !== '_' && props[k] != null && String(props[k]).length)
          .map((k) => ({ key: k, value: String(props[k]) }));
        const upd = await this.gql(CART_LINES_UPDATE, { cartId: this.cartId, lines: [{ id: edge.node.id, attributes: attributes }] });
        this.assertNoErrors(upd && upd.cartLinesUpdate, 'lines');
      }

      async flushCardNames() {
        const lines = [];
        this.form.querySelectorAll('[data-landie-co-card-input]').forEach((input) => {
          if (input.value.trim() !== (input.dataset.saved || '') && lines.indexOf(input.dataset.line) === -1) {
            lines.push(input.dataset.line);
          }
        });
        for (let i = 0; i < lines.length; i++) {
          await this.saveCardLine(lines[i]);
        }
      }

      async ensureCart() {
        if (this.cartId) return;
        const lines = await this.buildLines();
        if (!lines.length) throw new Error('Cart is empty');
        const input = { lines: lines };
        if (this.discountCode) input.discountCodes = [this.discountCode];
        const data = await this.gql(CART_CREATE, { input: input });
        const payload = data && data.cartCreate;
        this.assertNoErrors(payload, 'cartCreate');
        this.cartId = payload.cart.id;
        this.checkoutUrl = payload.cart.checkoutUrl;
        this.persistCart();
      }

      persistCart() {
        if (!this.cartId) return;
        try {
          localStorage.setItem('landie_co_cart', JSON.stringify({ id: this.cartId, code: this.discountCode || '' }));
        } catch (_) {}
      }

      clearPersisted() {
        try { localStorage.removeItem('landie_co_cart'); } catch (_) {}
      }

      async hydrate() {
        if (!this.token) return;
        let raw;
        try { raw = localStorage.getItem('landie_co_cart'); } catch (_) { return; }
        if (!raw) return;
        let saved;
        try { saved = JSON.parse(raw); } catch (_) { saved = null; }
        if (!saved || !saved.id) { this.clearPersisted(); return; }

        try {
          const data = await this.gql(CART_GET, { id: saved.id });
          const cart = data && data.cart;
          if (!cart || !cart.lines) { this.clearPersisted(); return; }

          // Only reuse the saved cart if it still mirrors the current cart.
          const savedSig = cart.lines.edges
            .map((e) => {
              const gid = (e.node.merchandise && e.node.merchandise.id) || '';
              return gid.split('/').pop() + ':' + e.node.quantity;
            })
            .sort()
            .join(',');
          const currentSig = (this.root.dataset.cartSignature || '').split(',').filter(Boolean).sort().join(',');
          if (savedSig !== currentSig) { this.clearPersisted(); return; }

          this.cartId = cart.id;
          const applied = cart.discountCodes && cart.discountCodes.find((d) => d.applicable);
          if (applied) {
            this.discountCode = applied.code;
            const input = this.root.querySelector('[data-landie-co-discount-input]');
            if (input) input.value = applied.code;
            this.applyTotals(cart.cost, this.totalDiscount(cart), applied.code);
          } else {
            this.discountCode = '';
          }
          this.persistCart();
        } catch (_) { /* ignore; a fresh cart is created on next action */ }
      }

      assertNoErrors(payload, label) {
        if (!payload) throw new Error(label + ': no response');
        if (payload.userErrors && payload.userErrors.length) {
          const e = new Error(payload.userErrors[0].message || (label + ' failed'));
          e.userFacing = true; // merchant-authored message safe to show (e.g. cart validation)
          throw e;
        }
      }

      async buildLines() {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('cart.js failed: ' + res.status);
        const cart = await res.json();
        return (cart.items || []).map((it) => {
          const line = {
            merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id,
            quantity: it.quantity,
          };
          const attrs = [];
          if (it.properties) {
            Object.keys(it.properties).forEach((k) => {
              const v = it.properties[k];
              if (k.charAt(0) !== '_' && v != null && String(v).length) {
                attrs.push({ key: k, value: String(v) });
              }
            });
          }
          if (attrs.length) line.attributes = attrs;
          if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
            line.sellingPlanId = 'gid://shopify/SellingPlan/' + it.selling_plan_allocation.selling_plan.id;
          }
          return line;
        });
      }

      async gql(query, variables) {
        const res = await fetch('https://' + this.domain + '/api/' + this.version + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token,
          },
          body: JSON.stringify({ query: query, variables: variables }),
        });
        const json = await res.json();
        if (json.errors && json.errors.length) {
          throw new Error(json.errors[0].message || 'GraphQL error');
        }
        return json.data;
      }

      bannerSlot() {
        return this.root.querySelector('[data-landie-co-banner-slot]');
      }

      showBanner(message) {
        const slot = this.bannerSlot();
        if (!slot) return;
        slot.innerHTML = '';
        const banner = document.createElement('div');
        banner.className = 'landie-co__banner';
        banner.setAttribute('role', 'alert');
        banner.textContent = message;
        slot.appendChild(banner);
        slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      clearBanner() {
        const slot = this.bannerSlot();
        if (slot) slot.innerHTML = '';
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => { new LandieCheckout(); });
    } else {
      new LandieCheckout();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
